<div  style="padding: 1em;">
  <ion-label>
    {{ ('keys.data.permits.lot_password_required' | translate )}}
  </ion-label>
  </div>
   
  
  